<ng-container *transloco="let t">
  <div class="pb-4">
    <app-nav-tabs [reduceHorizontalSpacing]=true>
      <app-nav-tab [title]="t('organiser.details.title')" [itemId]="1">
        <ng-template>
          <app-organiser-basic-data [currentOrganiser]="currentOrganiser" [organiserFormMode]="organiserFormMode"
                                    [countries]="countries"/>
        </ng-template>
      </app-nav-tab>
      <app-nav-tab [title]="t('app.common.users')" [itemId]="2">
        <ng-template>
          <div class="admin-card collapsible">
            <app-organiser-user-list [users]="users" [currentOrganiser]="currentOrganiser" (onUsersChange)="onUsersChange($event)"/>
          </div>
          @if (authenticationService.isAdministrator()) {
            <app-action-buttons-row [saveVisible]="false"/>
          }
        </ng-template>
      </app-nav-tab>
      <app-nav-tab [title]="t('organiser.payment.data')" [itemId]="3">title
        <ng-template>
          <app-organiser-payment-data-form [paymentData]="paymentData" [organiserId]="currentOrganiser?.id"
                                           (paymentDataChanged)="paymentDataChanged($event)" [currencies]="currencies"/>
        </ng-template>
      </app-nav-tab>
      <app-nav-tab [title]="t('organiser.details.smartphone.app.pin')" [itemId]="4">
        <ng-template>
          <div class="admin-card collapsible">
            {{ t("organiser.details.smartphone.app.pin") }}
          </div>
          @if (authenticationService.isAdministrator()) {
            <app-action-buttons-row [saveVisible]="false"/>
          }
        </ng-template>
      </app-nav-tab>
      @if (checkPermission('CATEGORIES_TAB')) {
        <app-nav-tab [title]="t('app.common.categories.list')" [itemId]="5">
          <ng-template>
            <app-categories-list [categoryTypes]="categoryTypes"/>
          </ng-template>
        </app-nav-tab>
      }
      @if (checkPermission('DISCOUNTS_TAB')) {
        <app-nav-tab [title]="t('app.common.discounts.management')" [itemId]="6">
          <ng-template>
            <app-list-of-discounts [listOfDiscounts]="listOfDiscounts" [isAdminRole]="true" [languages]="languages"
                                   (discountsChanged)="onDiscountsChanged($event)"/>
          </ng-template>
        </app-nav-tab>
      }
    </app-nav-tabs>
  </div>
</ng-container>
